import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, CircularProgress, Typography } from '@mui/material';
import { IoMdClose } from "react-icons/io";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useState } from 'react';
import SnackBar from '../../General/SnackBar';
import { HandleUpdateStatus } from 'API/UserList/CspList';

export default function StatusDialog(props) {


    console.log("props", props);

    const [Value,setValue] = useState(null)
    const [IsLoading,setIsLoading] = useState(false)
    const [AlertMessage,setAlertMessage] = useState(null)
    const [AlertType,setAlertType] = useState(null)
    const [AlertOpen,setAlertOpen] = useState(false)

    const handleAlertOpen=(message,type)=>{
        setAlertOpen(true)
        setAlertMessage(message)
        setAlertType(type)
    }

    const handleAlertClose=()=>{
        setAlertOpen(false)
    }


    const handleChange = (event) => {
        setValue(event.target.value)

    }

    const HandleStatusUpdate = () =>{
        // console.log("value", value);
        let data = {
            "agent_id": props.data&&props.data.row._id,
            "new_status": Value
        }
        // console.log("data", data);
        
        HandleUpdateStatus(data,setIsLoading,handleAlertOpen,props.handleClose,props.GetList)
    }
    


    return (
        <React.Fragment>
            <SnackBar open={AlertOpen} handleClose={handleAlertClose} message={AlertMessage} type={AlertType} />
            <Dialog
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">
                    <Typography variant='h4'>Status</Typography>
                </DialogTitle>
                <Box sx={{ position: 'absolute', right: 10, top: 10, cursor: 'pointer', fontSize: '22px' }} onClick={() => props.handleClose()}>
                    <IoMdClose />
                </Box>
                <DialogContent sx={{margin:0,paddingBlock:0}}>
                    <Box sx={{ minWidth: 120 ,m:0}}>
                        <FormControl fullWidth size='small'>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={Value?Value:""}
                                onChange={handleChange}
                            >
                                <MenuItem value={7}>Active</MenuItem>
                                <MenuItem value={99}>Deleted</MenuItem>
                                <MenuItem value={'R'}>Deactivated & Replaced</MenuItem>

                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center' ,mt:2}}>
                    <Button disabled={IsLoading} variant='contained' color='secondary' onClick={()=>HandleStatusUpdate()} size='small'>
                        {IsLoading?<CircularProgress size="20px" color='inherit'/>:"Save"}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
